import React from "react"
import SelectDropdown from "../SelectDropdown"
import FormSection from "../FormSection"
import TextInput from "../TextInput"

export default function Designer() {
  const yesNo = [
    { value: "", label: "Please Select" },
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ]

  return (
    <FormSection title="Your Designer">
      <div className="grid grid-cols-2 gap-y-6">
        <SelectDropdown
          label="Do you need someone to design a plan?"
          name="designer_required"
          as="select"
          options={yesNo}
          className="flex flex-col mr-32"
        />
        <div />
        <div className="flex flex-col mr-32">
          <div className="subtitle">
            <p>
              If <span className="text-tertiary">yes</span>
            </p>
          </div>
          <SelectDropdown
            label="would you like Builder Finders to refer you to a Building Designer/Architect?"
            name="builder_finders_refer_designer_architect"
            as="select"
            options={yesNo}
            className="flex flex-col mr-32"
          />
        </div>
        <div className="flex flex-col space-y-4 mr-32">
          <div className="subtitle">
            <p>
              If <span className="text-tertiary">no</span>
            </p>
            <p>
              and you have obtained drawings already please indicate the
              following information
            </p>
          </div>
          <TextInput
            label="Designer's Name"
            name="designer_name"
            type="text"
            className="flex flex-col"
          />
          <TextInput
            label="Designer's Phone Number"
            name="designer_number"
            type="text"
            className="flex flex-col"
          />
          <TextInput
            label="Designer's Email"
            name="designer_email"
            type="email"
            className="flex flex-col"
          />
        </div>
      </div>
    </FormSection>
  )
}
